export { default } from './ChatBubbleCautionOutline'
